'use client'

import { buttonStyles } from '@/core/components/form/button/button'
import SafeImage from '@/features/veluvit/components/ui/media-image'
import { cn } from '@/core/utils/common'

import PageHeader from '@/features/veluvit/components/shell/page-header'
import EmptyState from '@/features/veluvit/components/ui/empty-state'
import Link from 'next/link'
import { LuCamera } from 'react-icons/lu'
import { useAppData } from '@/features/veluvit/hooks/use-app-data'

/** 스냅 앨범 — 대화에서 남긴 장면. 컬렉션과 따로 보관한다 (v2-paid-extras ROUTES.snaps) */
export default function SnapsScreen() {
  const { data } = useAppData()
  const snaps = (data?.rooms || [])
    .flatMap((r) =>
      (r.snaps || []).map((s) => ({ ...s, name: r.work?.name || r.workId }))
    )
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))

  return (
    <>
      <PageHeader back title="스냅 앨범" />
      <section className="mt-6 px-4 pb-8 over10:content-column">
        <p className="text-t3">
          대화에서 남긴 장면이에요. 컬렉션과 따로 보관합니다.
        </p>
        {snaps.length ? (
          <div className="mt-4 grid grid-cols-[repeat(auto-fit,minmax(160px,1fr))] gap-4">
            {snaps.map((s) => (
              <figure key={s.id} className="m-0 max-w-90">
                <a
                  href={s.image}
                  target="_blank"
                  rel="noopener"
                  aria-label={`${s.name}의 대화 장면 크게 보기`}
                  className="relative block aspect-[2/3] overflow-hidden rounded-panel bg-surface shadow-[inset_0_0_0_1px_rgb(255_255_255/0.06)]"
                >
                  <SafeImage
                    src={s.image}
                    alt={`${s.name}의 대화 장면`}
                    fill
                    sizes="(min-width: 1001px) 360px, 50vw"
                    className="object-cover"
                    appearance="plain"
                    unoptimized
                  />
                </a>
                <figcaption className="my-2.5 text-t2">
                  {s.name} · {new Date(s.createdAt).toLocaleDateString('ko-KR')}
                </figcaption>
                <a
                  href={s.image}
                  download={`${s.id}.jpg`}
                  className={buttonStyles({
                    variant: 'secondary',
                    size: 'lg',
                    shape: 'pill',
                    bold: true,
                    className: cn('w-full', 'no-underline'),
                  })}
                >
                  이미지 저장
                </a>
              </figure>
            ))}
          </div>
        ) : (
          <EmptyState
            icon={<LuCamera />}
            title="아직 저장한 스냅이 없어요"
            description="대화에서 남긴 장면을 여기서 다시 볼 수 있어요."
            action={
              <Link
                href="/chats"
                className="text-point underline underline-offset-4 hover:text-point-soft focus-visible:text-point-soft"
              >
                내 대화 보기
              </Link>
            }
          />
        )}
      </section>
    </>
  )
}
